import Head from 'next/head';
import { getThemeCss } from '@/helpers/whiteLabel/theme';
import { WhiteLabelTheme as Theme } from '@/api/whiteLabelPublicApi';

/** Colors and favicon of the workspace that sent the document; rendered on the server, so the page does not flash in DataDoc colors */
const WhiteLabelTheme = ({ theme }: { theme?: Theme | null }) => {
  if (!theme?.enabled) return null;

  // html:root is more specific than the :root of the site stylesheets, which come after this tag in the head
  const css = getThemeCss(theme.colors, 'html:root');
  const favicon = theme.logos.favicon;

  return (
    <Head>
      {css && <style key="white-label-theme" id="white-label-theme" dangerouslySetInnerHTML={{ __html: css }} />}
      {favicon && <link key="white-label-favicon" rel="icon" href={favicon} />}
    </Head>
  );
};

export default WhiteLabelTheme;
